<template>

    <div>
        <div class="modal-header">
            <h5 class="modal-title">Peticionamento Eletrônico</h5>
            <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="showModal = false">
                <span aria-hidden="true">&times;</span>
            </button> -->
        </div>
        <div class="modal-body">
            


            <div class="form-container mb-3">
                <div class="form-title">Resumo das Informações</div>
                <div class="row">
                    <div class="col-12">
                        <div class="form-group mt-2">
                            <label><strong><i>Desejo entrar com a ação em:</i></strong></label>
                            <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ cidade }}
                        </div>
                        <div class="form-group mt-2">
                            <label><strong><i>Rito do Processo:</i></strong></label>
                            <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ rito }}
                        </div>
                        <div class="form-group mt-2">
                            <label><strong><i>Assunto Principal:</i></strong></label>
                            <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ assuntoPrincipal ? assuntoPrincipal.descricao : 'Não definido' }}
                        </div>
                        <div class="form-group mt-2">
                            <label><strong><i>Partes:</i></strong></label>
                            <ul v-if="$store.state.processo.polo_ativo && $store.state.processo.polo_ativo.length > 0" style="list-style-type: none;">
                                <li v-for="parte_ativa in $store.state.processo.polo_ativo">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ parte_ativa.nome }} {{ parte_ativa.principal == "1" ? " (Principal)" : "" }}</li>
                            </ul>
                            <ul style="list-style-type: none;">
                                <li>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong>X</strong></li>
                            </ul>
                            <ul v-if="$store.state.processo.polo_passivo && $store.state.processo.polo_passivo.length > 0" style="list-style-type: none;">
                                <li v-for="parte_passiva in $store.state.processo.polo_passivo">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ parte_passiva.nome }} {{ parte_passiva.principal == "1" ? " (Principal)" : "" }}</li>
                            </ul>
                        </div>
                        <div class="form-group mt-2">
                            <label><strong><i>Distribuição preparada por:</i></strong></label>
                            <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ criador }}
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-container mb-3">
                <div class="form-title">Documentos</div>
                <div class="row">
                    <div class="col-12">
                        <div class="form-group mt-2" v-if="$store.state.processo.peticoes && $store.state.processo.peticoes.length > 0 && $store.state.processo.peticoes[0].documentos && $store.state.processo.peticoes[0].documentos.length > 0">
                            <ul style="list-style-type: none;">
                                <li v-for="documento in $store.state.processo.peticoes[0].documentos">
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a :href="remove_barra_dupla(documento.path)" target="_blank">{{ documento.descricao }}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-container mb-3">
                <div class="form-title">Demais advogados no processo</div>
                <div class="row">
                    <div class="col-6">
                        <span><strong>Parte autora</strong></span>
                        <div class="form-group mt-2" v-if="$store.state.processo.advogados_colaboradores && $store.state.processo.advogados_colaboradores.length  > 0">
                            <ul style="list-style-type: none;">
                                <li v-for="adv in $store.state.processo.advogados_colaboradores">
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ adv.name }}
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-6">
                        <span><strong>Parte ré</strong></span>
                        <div class="form-group mt-2" v-if="$store.state.processo.advogados_reus && $store.state.processo.advogados_reus.length  > 0">
                            <ul style="list-style-type: none;">
                                <li v-for="adv in $store.state.processo.advogados_reus">
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ adv.name }}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>

</template>
  
<script>

export default {
    data() {
        return {
            BASE_URL: window.Laravel.baseUrl,
            cidade: '',
            rito: '',
            criador: '',
        };
    },
    methods: {
        async BuscarInformacoesResumo(){

            let cidade_id = this.$store.state.processo.cidade_id;
            let rito_id = this.$store.state.processo.rito_id;
            let criado_por = this.$store.state.processo.criado_por;

            try {
                // Fazendo a requisição GET com parâmetros
                const response = await axios.get(this.BASE_URL + `processo/buscar-resumo`, {
                    params: {
                        cidade_id,
                        rito_id,
                        criado_por
                    }
                });

                this.cidade = response.data.cidade;
                this.rito = response.data.tipo_rito;
                this.criador = response.data.criador;
            } catch (error) {
                // Lidando com erros
                console.error(error);
            }
        },
        remove_barra_dupla(path) {
            // Adiciona o caminho ao URL base e substitui somente barras duplas que não seguem diretamente os dois pontos
            return `${this.BASE_URL}${path}`.replace(/(https?:\/\/)|(\/+)/g, (match, p1) => p1 ? p1 : '/');
        },
    },
    mounted() {
        this.BuscarInformacoesResumo();
    },
    computed: {
        assuntoPrincipal() {
            const principal = this.$store.state.processo.assuntos.find(assunto => assunto.principal === true);
            return principal ? principal : null;
        }
    }

};
</script>
  
<style scoped>
.form-container {
    border: 1px solid gray; /* Borda fina cinza */
    padding: 10px;
    position: relative; /* Posição relativa para o posicionamento do título */
    margin-top: 5px; /* Espaçamento superior para visualização do título */
    margin-left: 5px;
    margin-right: 5px;
    border-radius: 5px;
    background-color: #FFFFFF;
}

.form-title {
    position: absolute; /* Posicionamento absoluto do título */
    top: -15px; /* Posiciona o título acima da borda */
    left: 10px; /* Espaçamento da esquerda para o título */
    background: white; /* Fundo branco para o título */
    padding: 0 1px; /* Espaçamento interno do título */
    font-weight: bold;;
}

</style>
  
